module.exports = __webpack_public_path__ + "img/assistive-listening-systems.26fa2cf9.svg";